var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-container-layout',{staticClass:"project-index",attrs:{"nav-title":"404: PAGE NOT FOUND"}})}
var staticRenderFns = []

export { render, staticRenderFns }